module.exports = __webpack_public_path__ + "static/media/WELL-BUSD.1dd46bd4.svg";